import { render, staticRenderFns } from "./JKCompanyUserDownload.vue?vue&type=template&id=6b892dbe&scoped=true"
import script from "./JKCompanyUserDownload.vue?vue&type=script&lang=js"
export * from "./JKCompanyUserDownload.vue?vue&type=script&lang=js"
import style0 from "./JKCompanyUserDownload.vue?vue&type=style&index=0&id=6b892dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b892dbe",
  null
  
)

export default component.exports